import React, { memo, useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Paper, IconButton, Tooltip } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Row, Col } from "reactstrap";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { attrNames, booleanAttr, dateAttr, numberAttr, percentAttr, priceAttr, formatValue } from './TransactionAttributes';
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import excelicon from "../../../../Assets/Images/excel-icon.png";
import { SpanMessage } from '../../../../helpers/componentHelper';
import { useNavigate} from "react-router-dom";
import { isS3Url } from '../../../../helpers/dataHelper';
import { apiCommonTrigger, apiCommonTriggerBlob } from '../../../../Utils/apiServicehelper';
import { Config } from '../../../../Utils/Config';
const apiPath = process.env.REACT_APP_API_URL;

const transactionOnlyAttNames = [
    "dateListed",
    "dateSold",
    "confidential",
    "listingPrice",
    "salePricePublicSource",
    "salePriceSelfReported",
    "partofPortfolio",
    "portfolioPercentage",
    "saleTypeName",
    "capRate",
    "noi",
    "buyer",
    "seller",
    "pricePerUnit",
    "pricePerSQFT",
    "descriptionExecutiveSummary",
    "investmentHighlights"
];

const Transaction = (props) => {
    const navigate = useNavigate();
    const { activeTabCount, MarketID, reportDownloadMsg } = props;
    const [accordionId, setAccordionId] = useState(1);
    const [loader, setLoader] = useState(false);
    const [download, setDownload] = useState(false);
    const [accordionOpen, setAccordionOpen] = useState(false);
    const [transData, setTransData] = useState({
        properties: [],
        transactions: [],
        transactionContacts: [],
        facilities: [],
        deedInfos: [],
        documents: [],
    });
    const widgetId = 21;
    const [avoidPdfMultipleCliks, setAvoidPdfMultipleCliks] = useState(true);
    const [avoidExcelMultipleCliks, setAvoidExcelMultipleCliks] = useState(true);

    useEffect(() => {
        if (activeTabCount === "2") {
            getUpdatedKD();
        }
    }, [activeTabCount]);

    const getUpdatedKD = () => {
        setLoader(true);
        apiCommonTrigger("get" , Config.API_URL + "/KnownDev/salestransaction/", [MarketID])
            .then((res) => {
              if (res.status === 200) {
                const { properties, transactions, transactioncontacts, facilities, deedinfos, documents } = res.data;
                setTransData({ properties, transactions, transactionContacts:transactioncontacts, facilities, deedInfos:deedinfos, documents });
                setLoader(false);
              } else {
                setLoader(false);
                handlingCatchError(res, navigate);
              }
            })
            .catch((err) => {
                setLoader(false);
              handlingCatchError(err, navigate);
            });
    }


    const exportCompExcel = () => {
        const { MarketID } = props;
        setAvoidExcelMultipleCliks(false);
        let timestamp = new Date().getDate() + "" + new Date().getMonth() + "" +
            new Date().getFullYear() + "" + new Date().getTime();
        let fileName = MarketID + "_Transaction_" + timestamp + ".xlsx";
         apiCommonTriggerBlob("get",`${Config.API_URL}/KnownDev/salestransaction/excel/`,[MarketID])
        .then((res) => {
          let link = document.createElement('a');
          const isSuccess = res.status === 200;
          const isUnauthorized = res.status === 401;
      
          if (isSuccess) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            // For Firefox, delay revoking the ObjectURL
            setTimeout(() => {
              window.URL.revokeObjectURL(link.href);
              link.remove();
            }, 3000);
          } else if (isUnauthorized) {
            navigate("/");
            return; // Exit early if unauthorized
          }      
          setAvoidExcelMultipleCliks(true);
        })
        .catch((error) => {
          handlingCatchError(error, navigate);
          setAvoidExcelMultipleCliks(true);

        });
    }

    const exportCompPDF = () => {
        const { MarketID } = props;
        setAvoidPdfMultipleCliks(false);

        let timestamp = new Date().getDate() + "" + new Date().getMonth() + "" +
            new Date().getFullYear() + "" + new Date().getTime();

        let fileName = MarketID + "_Transaction_" + timestamp + ".pdf";
        reportDownloadMsg(
            true,
            "Your download is being processed. The " + fileName + " file will download automatically to your browser when ready. Please do not close or refresh the window until the download is complete. We recommend you check your Downloads folder if you don’t see it in your browser.",
            "snack-success",
        );
        let inputData = {
            marketid: MarketID?parseInt(MarketID):0,
            filename: fileName
        };
        apiCommonTriggerBlob("post",`${Config.API_URL}/KnownDev/report/transaction`,inputData)
        .then((res) => {
          let link = document.createElement('a');
          const isSuccess = res.status === 200;
          const isUnauthorized = res.status === 401;
      
          if (isSuccess) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            // For Firefox, delay revoking the ObjectURL
            setTimeout(() => {
              window.URL.revokeObjectURL(link.href);
              link.remove();
            }, 3000);
          } else if (isUnauthorized) {
            navigate("/");
            return; // Exit early if unauthorized
          }      
          setAvoidPdfMultipleCliks(true);
        })
        .catch((error) => {
          setAvoidPdfMultipleCliks(true);
          handlingCatchError(error, navigate);
        });
    };

    const downloadDocumentCenter = (docData) => {
        const { MarketID } = props;
        setDownload(true);
        let { id, documenttype, documenttypeid,filename } = docData;

        const isS3UrlBool = isS3Url(filename);
    
        if(!isS3UrlBool && filename){
            window.open(filename, "_blank");
            return true;
        }

        let fileURLIndex = filename.lastIndexOf(".");
        let extension = filename.slice(fileURLIndex);
        let pdfURL = "knowndev/documentcenter/" + id + "/" + documenttypeid + "/2";
        let date = new Date();
        let monthCal = date.getMonth() + 1;
        let dateFormat = date.getFullYear() + "-" + monthCal + "-" + date.getDate();
        let downloadFileName = documenttype.replaceAll(" ", "") + "_" + dateFormat + extension;

        const inputType = {
          facilityid : id, 
          doctypeid: documenttypeid, 
          doccentertypeid : 2
        }
        apiCommonTriggerBlob("post",`${Config.API_URL}/knowndev/documentcenter`, inputType)
          .then((res) => {
            let link = document.createElement('a');
            const isSuccess = res.status === 200;
            const isUnauthorized = res.status === 401;
        
            if (isSuccess) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              link.href = url;
              link.setAttribute('download', downloadFileName);
              document.body.appendChild(link);
              link.click();
              // For Firefox, delay revoking the ObjectURL
              setTimeout(() => {
                window.URL.revokeObjectURL(link.href);
                link.remove();
              }, 3000);
            } else if (isUnauthorized) {
              navigate("/");
              return; // Exit early if unauthorized
            }else{
              handlingCatchError(res, navigate);
            }   
  
            setDownload(false);
          })
        .catch((err) => {
          setDownload(false);
          handlingCatchError(err, navigate);
        });

    }

    const accordionChange = (id) => {
        if (accordionId === id) setAccordionOpen(!accordionOpen);
        else {
            setAccordionId(id);
            setAccordionOpen(true);
        }
    }

    const emptyData = (data) => {
        let dataDt = { ...data };
        for (const key in dataDt) dataDt[key] = null;
        return dataDt;
    }

    const getReferenceData = (data) => {
        let refData = [];
        if (data.length === 1) return data[0];
        for (let index = 1; index < data.length; index++) {
            if (index === 1) refData.push(...data[0]);

            let cmpObj1 = refData.length > data[index].length ? refData : data[index];
            let cmpObj2 = refData.length < data[index].length ? refData : data[index];
            let cmpData = [...cmpObj1];
            let cmpObj = cmpObj2.filter(ft => !cmpData.includes(ft));

            for (let index = 0; index < cmpObj.length; index++) {
                let pos = cmpObj2.findIndex(ft => ft === cmpObj[index]);
                let pos1 = cmpData.findIndex(ft => ft === cmpObj2[pos - 1]);
                let pos2 = -1;
                if (pos1 === -1) pos2 = cmpData.findIndex(ft => ft === cmpObj2[pos + 1]);
                let addpos = pos2 !== -1 ? (pos2 - 1) : pos1;
                cmpData.splice((addpos + 1), 0, cmpObj[index]);
            }
            refData = cmpData;
        }
        return refData;
    }

    const displayContent = useCallback((id, profileid, transaction, contact, facility, deedInfo, docInfo) => {

        if (activeTabCount === "2" && accordionOpen && accordionId === id) {
            let avoidAttr = ["id", "storeid", "saletypeid","masterid" , 'facilityid' , 'ownershiptype', 'profileid'];

            let transDt = transaction.filter(ft => ft.profileid === profileid);
            let contactDt = contact.filter(ft => ft.profileid === profileid);
            let falcDt = facility.filter(ft => ft.profileid === profileid);
            let deedDt = deedInfo.filter(ft => ft.profileid === profileid);
            let docDt = docInfo.filter(ft => ft.profileid === profileid && ft.filename);
            let docTypeList = docDt.map(ft => ft.documenttype).filter((x, i, a) => a.indexOf(x) === i);
            let contactKeyList = contactDt?.map(dt => Object.keys(dt || {}).filter(ft => !avoidAttr.includes(ft) && dt[ft]))?.sort((a, b) => a.length > b.length ? -1 : 1)[0] ?? [];

            let data = [];
            let documentDataList = [];
            let transContactList = [];

            for (let i = 0; i < transDt.length; i++) {
                let docFt = docDt.filter(ft => ft.id === transDt[i].id);
                let deedData = deedDt.filter(ft => ft.id === transDt[i].id);
                let contactFt = contactDt.filter(ft => ft.id === transDt[i].id);
                documentDataList.push(docFt);
                transContactList.push(contactFt);
                let falcDtExist = falcDt?.map(dt => Object.keys(dt || {}).some(ft => !avoidAttr.includes(ft) && dt[ft]))?.includes(true);
                let falcFt = falcDt.length > 0 ? falcDt.filter(ft => ft.id === transDt[i].id) : [];
                let falcData = falcFt.length > 0 ? falcFt : [emptyData(falcDt[0])];

                data.push({
                    ...transDt[i],
                    ...({ transContactData: contactDt.length > 0 ? true : false }),
                    ...([falcDt[0]]?.map(dt => Object.keys(dt || {}).filter(ft => !avoidAttr.includes(ft) && dt[ft]))[0]?.length > 0 || falcDtExist ? { facTitle: "ST", ...falcData[0] } : {}),
                    ...([deedData[0]]?.map(dt => Object.keys(dt || {}).filter(ft => !avoidAttr.includes(ft) && dt[ft]))[0]?.length > 0 ? { deedTitle: "ST", ...deedData[0] } : {}),
                    ...({ documentData: docDt.length > 0 ? true : false }),
                });
            }

            let existingData = data.map(dt => Object.keys(dt).filter(ft => !avoidAttr.includes(ft) && dt[ft]));
            let reference = getReferenceData(existingData);
            // let reference = existingData.sort((a, b) => a.length > b.length ? -1 : 1)[0];
            let noData = reference.length === 0;
            let referenceData = !noData ? [...reference] : [""];
            let accordionData = [...data];

            return (
                <>
                    {accordionData.map((ft, idx) =>
                        <Col md={4}>
                            <table className='table table-sm table-bordered table-striped' key={`acc_trans_${Math.random()}`}>
                                <thead>
                                    <th colSpan={2}>Transaction {(idx + 1)}</th>
                                </thead>
                                <tbody>
                                    {referenceData.map((dt, idy) =>
                                        dt === "documentData" ?
                                            <>
                                                <tr className='child-heading'>
                                                    <td colSpan={2}>Document Center</td>
                                                </tr>
                                                {docTypeList.map(docType => {
                                                    let viewData = documentDataList[idx].filter(dcFT => dcFT.documenttype === docType);
                                                    return (
                                                        <tr key={`table_${Math.random()}`} className='sub-menu'>
                                                            <td>{docType}</td>
                                                            {viewData?.length > 0 ?
                                                                <td><span onClick={() => downloadDocumentCenter(viewData[0])} className="d-center-download-link">Click to view and download</span></td>
                                                                : <td>-</td>}
                                                        </tr>);
                                                })}
                                            </>
                                            :
                                            dt === "transContactData" && contactKeyList.length > 0 ?
                                                <>
                                                    <tr className='child-heading'>
                                                        <td colSpan={2}>Transaction Contacts</td>
                                                    </tr>
                                                    {(transContactList[idx].length ? transContactList[idx] : [{}]).map((cDt, cIdx) =>
                                                        <>
                                                            {transContactList[idx].length > 1 && (<tr key={`table_${Math.random()}`}><td colSpan={2}>Contact {cIdx + 1}</td></tr>)}
                                                            {contactKeyList.map(cObj => {
                                                                return (
                                                                    attrNames[cObj] && (
                                                                        <tr key={`table_${Math.random()}`} className='sub-menu'>
                                                                            <td>{attrNames[cObj]}</td>
                                                                            <td>{cDt?.[cObj] ? cDt[cObj] : "-"}</td>
                                                                        </tr>));
                                                            })}
                                                        </>
                                                    )}
                                                </>
                                                : dt !== "ownershiptype" ? (
                                                    <tr key={`table_${Math.random()}`} className={`${(ft[dt] === "ST" ? "child-heading" : ((!transactionOnlyAttNames.includes(dt) && ft[dt] !== "ST") ? "sub-menu" : ''))}`}>
                                                        <td colSpan={ft[dt] !== "ST" ? 1 : 2}>{attrNames[dt]}</td> {/* className={(dt === "investmentHighlights") || (dt === "descriptionExecutiveSummary") ? "vertical-align-top" : ""} */}
                                                        {ft[dt] !== "ST" && (
                                                            <td className=''>
                                                                {ft[dt] ? (
                                                                    dateAttr.includes(dt) ? formatValue("Date", ft[dt])
                                                                    : priceAttr.includes(dt) ? formatValue("Currency", ft[dt])
                                                                    : numberAttr.includes(dt) ? formatValue("Number", ft[dt])
                                                                    : percentAttr.includes(dt) ? formatValue("Percentage", ft[dt])
                                                                    : booleanAttr.includes(dt) ? (ft[dt] ? "Yes" : "No")
                                                                    : ft[dt]
                                                                ) : "-"}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ) : null
                                            )}
                                </tbody>
                            </table></Col>)}
                </>);
        }
    }, [accordionId, accordionOpen, activeTabCount]);

    return (
        <>
            {(loader || download) && (<div className="loader-wrap">
                <div className="loading loading-center"></div>
            </div>)}
            {!loader && <>
                <Row className='mb-2 mt-3 pb-1'>
                    <Col md="10">
                        <p className="font-sz-13 lne-hgt20 mb-0">
                            Sales transactions occurred from 2019 - till date on the facilities in the market. Each transaction profile includes information such as Sale Price, Date Listed, Date Sold, Deed Information, Deed Type etc.
                        </p>
                    </Col>
                    {transData.properties.length > 0 &&
                        <Col
                            md="2"
                            className="float-right text-right competitor-nav se-competitor-menu"
                            style={{ marginTop: '-5px' }}
                        >
                            <div className='download-all-btn'>
                                <b>Download:</b>
                                <span
                                    onClick={() => avoidPdfMultipleCliks && exportCompPDF()}
                                    style={{ cursor: "pointer", marginRight: "10px" }}
                                    className='remove-widgets pdf-down-btn'
                                    data-html2canvas-ignore
                                >
                                    <Tooltip title="Download widget" placement="top">
                                        <IconButton aria-label="export">
                                            <PictureAsPdfIcon />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                                <span
                                    onClick={() => avoidExcelMultipleCliks && exportCompExcel()}
                                    style={{ cursor: "pointer", marginRight: "10px" }}
                                    className='remove-widgets pdf-down-btn'
                                    data-html2canvas-ignore
                                >
                                    <Tooltip title="Download excel" placement="top">
                                        <IconButton aria-label="export">
                                        <img src={excelicon} alt="excel-icon"  style={{width:"18px"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </div>
                        </Col>}
                </Row >
                <div className="overflow-scroll-table br-0 overflow-scroll-table-kd transaction-section">
                    <Paper className="bx-sh-0">
                        {transData.properties.length > 0 ? transData.properties.map((dt, item) => {
                            const deedInfo = transData.deedInfos.find(deed => deed.profileid === dt.profileid);

                            return (
                                <Accordion
                                    key={"transaction-accordion-" + (item + 1)}
                                    expanded={accordionId === (item + 1) && accordionOpen}
                                    onChange={() => {
                                        accordionChange(item + 1);
                                    }}
                                >
                                    <AccordionSummary
                                        className="pl-0"
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={item + 1}
                                        id={item + 1}
                                    >
                                        <h4
                                            style={{
                                                display: "inlineBlock",
                                                fontSize: "13px",
                                                color: "#606060",
                                                marginBottom: '0px'
                                            }}
                                        >
                                            {dt.propertyname && `${dt.propertyname}, `}
                                            <span className='tab-address'>
                                                {[
                                                    dt.address && dt.address,
                                                    dt.city && dt.city,
                                                    dt.state && dt.state,
                                                    dt.zipcode && dt.zipcode
                                                ]
                                                    .filter(Boolean) // Remove falsy values (null, undefined, empty string)
                                                    .join(', ')}

                                                {deedInfo?.ownershiptype ? ` (${`Ownership Type: ${deedInfo.ownershiptype}`})` : ""}
                                            </span>
                                        </h4>
                                    </AccordionSummary>
                                    <AccordionDetails className='trans-accordion-values'>
                                        {
                                            transData.transactions.length > 0 && transData.transactions.filter(ft => ft.profileid === dt.profileid)?.length > 0 ?
                                                <div className='transaction-table'>
                                                    <Row>
                                                        {displayContent(item + 1, dt.profileid, transData.transactions, transData.transactionContacts, transData.facilities, transData.deedInfos, transData.documents)}
                                                    </Row>
                                                </div>
                                                : SpanMessage("transactions")
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            );
                        }) : SpanMessage("transactions")}
                    </Paper>
                </div>
            </>}
        </>
    )
}

const Condition = (prevProps, nextProps) => {
    if (nextProps.activeTabCount === "2")
        return false;
    else return true;
}

export default memo(Transaction, Condition);